import Marquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";
import { SITE } from "@/constants/site";

const WORDS = [
  "Play-Based Learning",
  "Safe & Nurturing",
  SITE.sanskrit,
  "Low Student-Teacher Ratio",
  "RBSE Based Pattern",
  "Since 2012",
  "Joyful Classrooms",
];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="relative -rotate-1 my-4">
    <div className="bg-brand-sun py-4 shadow-[0_10px_30px_rgba(251,191,36,0.3)]">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-6 flex items-center gap-6 font-display text-lg md:text-xl font-semibold text-ink">
            <span className={w === SITE.sanskrit ? "font-deva" : ""}>{w}</span>
            <Sparkles className="h-5 w-5 text-brand-deepcoral fill-brand-deepcoral/20" />
          </span>
        ))}
      </Marquee>
    </div>
  </div>
);
